export default "__VITE_ASSET__CW71oLPu__"